//! @ngInject
export function billingExportDetailsCtrl(
  $scope,
  $rootScope,
  NgTableParams,
  $stateParams,
  DatabaseApi,
  generalUtils,
  toaster
) {
  $scope.exportBatch = null;
  const initializeMap = DatabaseApi.entitiesInitializeMap();
  $scope.assetsAreReady = false;

  function initialize() {
    $scope.isLoading = true;    
    $scope.contractTypes = DatabaseApi.contractTypes() || [];
    checkEssentialAssets();
    if (!$scope.assetsAreReady) return;        

    $scope.exportBatch = $stateParams.export;

    let exportBatchId =
      ($scope.exportBatch && $scope.exportBatch.id) ||
      generalUtils.getLastPartInUrlPath();
    if (exportBatchId) {
      let url =
        "agencies/" +
        $rootScope.agencyId +
        "/agency_members/" +
        $rootScope.agencyMemberId +
        "/export_batches/" +
        exportBatchId;

      DatabaseApi.get(url).then(
        function (res) {
          initTable(res.data.visitInstances);
          initAdministrativePaymentTables(res.data.administrativePayments);
          $scope.isLoading = false;
        },
        function (error) {
          toaster.pop("error", "Failed to load the export batch details");
          $scope.isLoading = false;
        }
      );
    }
  }

  let mapItems = function (items) {    
    items.forEach(function (item) {
      if (!item.contractTypeName && item.contractId) {
        let contractType = $scope.contractTypes.find(c => {
          return c.id == item.contractId
        });
        item.contractTypeName = (contractType && contractType.name) || item.contractId;
      }

    });
  };

  function checkEssentialAssets() {
    // Patients are resolved per row now, so they are not an asset to wait for.
    const contractTypesState = initializeMap['contractTypes'];

    if (contractTypesState) {
        $scope.assetsAreReady = true;
        return;
    }
    $scope.assetsAreReady = false;
    return;
  }

  let initTable = function (items) {
    let options = {
      count: 25
    };

    mapItems(items);

    $scope.tableParams = new NgTableParams(options, {
      dataset: items
    });
  };

  let initAdministrativePaymentTables = function (items) {
    let options = {
      count: 25
    };

    items.forEach(function (item) {
      item.monthDisplay = `${item.month.year}-${item.month.month < 10 ? "0" : ""}${item.month.month} `;
    });    

    $scope.administrativePaymentTableParams = new NgTableParams(options, {
      dataset: items
    });
  }

  $scope.getSignedUrl = function (row) {
    DatabaseApi.get("agencies/" + $rootScope.agencyId + "/agency_members/" + $rootScope.agencyMemberId + "/export_batches/signed_url/" + row.id).then(res => {
      generalUtils.downloadURI(res.data.url, `medflyt-export-batch-${row.contractName}-${row.displayId}`)
    }, function (error) {
      toaster.pop("error", "Failed to download file from cloud");
    });
  }

  $rootScope.$on("got_contract_types", () => {
    checkEssentialAssets();

    if ($scope.assetsAreReady) {
        initialize();
    }
  });

  $rootScope.$on("got_contract_types", () => {
    $scope.contractTypes = DatabaseApi.contractTypes();
    checkEssentialAssets();

    if ($scope.assetsAreReady) {
        initialize();
    }
  });

  $scope.clickTableRow = function (row) {
    if (!row) return;
    $rootScope.openVisitInstanceModal(row.id);
  };

  initialize();
  $scope.$on("refresh_visits", function () {
    initialize();
  })
};
